/**
 * Append an random postfix to the itemId to make it unique.
 * Math.random should be unique because of its seeding algorithm.
 */
export const generateId = (itemId: string): string =>
  `${itemId}_${Math.random().toString(36).substr(2, 9)}`
